import React, { useState, useEffect } from 'react';
import useAuthStore from '../../store/authStore';
import apiClient from '../../services/api';

/**
 * Componente para cargar imágenes que requieren autenticación
 * Convierte la imagen en un blob y la muestra con un data URL
 */
const AuthImage = ({ src, alt, className, onError }) => {
  const [imageSrc, setImageSrc] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const { token } = useAuthStore();

  useEffect(() => {
    if (!src) {
      setLoading(false);
      return;
    }

    const loadImage = async () => {
      // Construir la URL correcta
      // Si src empieza con /imagenes, construir URL completa
      let imageUrl = src;
      if (src.startsWith('/imagenes/')) {
        imageUrl = `http://172.17.249.98:9099${src}`;
      }

      try {
        setLoading(true);
        setError(false);

        console.log('🖼️ Cargando imagen:', imageUrl);

        // Hacer petición con autenticación
        const response = await apiClient.get(imageUrl, {
          responseType: 'blob',
          headers: {
            Authorization: `Bearer ${token}`
          }
        });

        // Crear URL del blob
        const imageObjectURL = URL.createObjectURL(response.data);
        setImageSrc(imageObjectURL);
        console.log('✅ Imagen cargada exitosamente:', imageUrl);
      } catch (err) {
        console.error('❌ Error cargando imagen:', imageUrl, err);
        setError(true);
        if (onError) onError(err);
      } finally {
        setLoading(false);
      }
    };

    loadImage();

    // Cleanup: liberar el objeto URL cuando el componente se desmonte
    return () => {
      if (imageSrc) {
        URL.revokeObjectURL(imageSrc);
      }
    };
  }, [src, token]);

  if (!src) return null;
  if (loading) {
    return (
      <div className={`${className} bg-gradient-to-br from-neutral-100 to-neutral-200 animate-pulse flex items-center justify-center relative overflow-hidden`}>
        <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/30 to-transparent animate-shimmer"></div>
        <div className="relative flex flex-col items-center gap-1">
          <svg className="w-6 h-6 text-neutral-400 animate-spin" fill="none" viewBox="0 0 24 24">
            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
          </svg>
        </div>
      </div>
    );
  }
  if (error) {
    return (
      <div className={`${className} bg-neutral-100 flex items-center justify-center`}>
        <div className="text-center">
          <div className="text-2xl mb-1">📷</div>
          <p className="text-xs text-neutral-400">Error al cargar</p>
        </div>
      </div>
    );
  }

  return (
    <img 
      src={imageSrc} 
      alt={alt} 
      className={className}
      onError={(e) => {
        setError(true);
        if (onError) onError(e);
      }}
    />
  );
};

export default AuthImage;
